import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportMavenirConfigs } from '@api/dataSources';

import { IMavenirConfigFilter } from '@interfaces/cmModule/dataSources';
import { IFilter, IGroupOperationWithActionDTO } from '@interfaces/common/defaultDTO';

import { EMenuActionsTypes, ESnackbarTypes } from '@enums/common';

import { MAVENIR_CONFIG_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IMavenirConfigsExportReturnType {
	exportConfigs: (dto: IGroupOperationWithActionDTO) => void;
	isLoadingExportConfigs: boolean;
}

export function useMutateMavenirConfigsExport({
	filter,
}: IFilter<IMavenirConfigFilter>): IMavenirConfigsExportReturnType {
	const dispatch = useAppDispatch();

	const {
		mutate: exportConfigs,
		isLoading: isLoadingExportConfigs,
	} = useMutation<IGroupOperationWithActionDTO>({
		mutationKey: [MAVENIR_CONFIG_EXPORT],
		mutationFn: ({ ids, actionType }: IGroupOperationWithActionDTO) => {
			return exportMavenirConfigs({
				filter: (actionType === EMenuActionsTypes.allFiltered) && filter
					? filter
					: null,
				ids,
				isAll: actionType === EMenuActionsTypes.all || actionType === EMenuActionsTypes.allFiltered,
			});
		},
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingNotificationSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportConfigs,
		isLoadingExportConfigs,
	};
}
